class StoreDeviceInput {
  constructor (
    id = undefined,
    deviceId,
    deviceModelInputId,
    predefinedEventId,
    activated,
    updatedAt
  ) {
    this.id = id
    this.deviceId = deviceId
    this.device = null
    this.deviceModelInputId = deviceModelInputId
    this.deviceModelInput = null
    this.predefinedEventId = predefinedEventId
    this.predefinedEvent = null
    this.activated = activated
    this.updatedAt = updatedAt
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      // deviceId is read-only
      deviceModelInputId: this.deviceModelInputId,
      predefinedEventId: this.predefinedEventId
      // updatedAt is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    deviceId,
    deviceModelInputId,
    predefinedEventId,
    activated,
    updatedAt
  }) {
    return new StoreDeviceInput(
      id,
      deviceId,
      deviceModelInputId,
      predefinedEventId,
      activated,
      updatedAt
    )
  }

  toJSON () {
    return {
      id: this.id,
      deviceId: this.deviceId,
      deviceModelInputId: this.deviceModelInputId,
      predefinedEventId: this.predefinedEventId,
      activated: this.activated,
      updatedAt: this.updatedAt
    }
  }

  static FromJSON ({
    id,
    deviceId,
    deviceModelInputId,
    predefinedEventId,
    activated,
    updatedAt
  }) {
    return new StoreDeviceInput(
      id,
      deviceId,
      deviceModelInputId,
      predefinedEventId,
      activated,
      updatedAt
    )
  }
}

export default StoreDeviceInput
